import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { FC, useState } from "react";
import {
  MuiBox,
  MuiButtonPrimary,
  MuiButtonSecondary,
  MuiButtonTertiary,
} from "../../../../components";
import { COMPONENT_IDS } from "../../../../helpers/constants/componentIds";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { CancelFieldModal } from "../../../createProgramTemplate/components/cancelFieldModal/CancelFieldModal";
import { CreateProgramFooterWrapper } from "./CreateProgramFooter.style";

interface CreateProgramFooterProps {
  pageId: string;
  onConfirmClick: () => void;
  handleNavigateBack: () => void;
  isFiledUpdated: boolean;
  confirmButtonText: string;
  showBackButton?: boolean;
  handleBackButtonClick?: () => void;
  cancelMessage?: string;
  isFromTransfer?: boolean;
  handleDeleteApi?: () => void;
  cancelButtonText?: string;
  confirmationTitle?: string;
}

export const CreateProgramFooter: FC<CreateProgramFooterProps> = ({
  pageId,
  onConfirmClick,
  handleNavigateBack,
  isFiledUpdated,
  confirmButtonText,
  showBackButton = false,
  handleBackButtonClick,
  cancelMessage,
  isFromTransfer = false,
  handleDeleteApi,
  cancelButtonText,
  confirmationTitle,
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { commonLabels } = useSiteCore();

  const handleModalClose = () => {
    setShowCancelModal(false);
  };

  const onCancelButton = () => {
    if (isFromTransfer || isFiledUpdated) {
      setShowCancelModal(true);
    } else {
      handleNavigateBack();
    }
  };

  const handleOkClick = () => {
    if (isFromTransfer) {
      handleDeleteApi?.();
    } else {
      handleModalClose();
      handleNavigateBack();
    }
  };

  return (
    <CreateProgramFooterWrapper>
      <MuiBox>
        {showBackButton && (
          <MuiButtonTertiary
            data-testid={`${pageId}-back`}
            onClick={handleBackButtonClick}
          >
            <ArrowBackIosIcon />
            {commonLabels.back}
          </MuiButtonTertiary>
        )}
      </MuiBox>
      <MuiBox className="button-group">
        <MuiButtonSecondary id={`${pageId}-cancel`} onClick={onCancelButton}>
          {cancelButtonText ?? commonLabels.cancel}
        </MuiButtonSecondary>
        <MuiButtonPrimary
          onClick={onConfirmClick}
          data-testid={COMPONENT_IDS.UPDATE_BUTTON}
          id={`${pageId}-confirm`}
        >
          {confirmButtonText}
        </MuiButtonPrimary>
      </MuiBox>
      {showCancelModal && (
        <CancelFieldModal
          showModal={showCancelModal}
          handleModalClose={handleModalClose}
          handlePrimaryButtonClick={handleOkClick}
          cancelMessage={cancelMessage}
          title={confirmationTitle}
        />
      )}
    </CreateProgramFooterWrapper>
  );
};
